import PropTypes from 'prop-types'
import validator from 'validator'

export const validate = values => {
  const requiredFields = ['classification', 'description']
  const errors = {}

  requiredFields.forEach(field => {
    if (!values[field]) errors[field] = 'Campo Obrigatório'
  })

  return errors
}
